import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconGift1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="gift-1, present"><path d="M12 7.75V6.08333M12 7.75H10.3333C8.49238 7.75 7 6.25762 7 4.41667C7 3.49619 7.74619 2.75 8.66667 2.75C10.5076 2.75 12 4.24238 12 6.08333M12 7.75H13.6667C15.5076 7.75 17 6.25762 17 4.41667C17 3.49619 16.2538 2.75 15.3333 2.75C13.4924 2.75 12 4.24238 12 6.08333M12 7.75V20.25M4.75 12V20.25H19.25V12M4.75 12H19.25M4.75 12H3.75V7.75H20.25V12H19.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconGift1;
